import { useEffect, useRef, useState } from "react";

export const useSearchProgress = ({
  loading,
  showDelay = 3000,
  incrementInterval = 1200,
  maxDuration = 30000, // 30 seconds max
}) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);

  const intervalRef = useRef(null);
  const delayRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (loading) {
      setProgress(0);
      setIsTimeout(false);

      delayRef.current = setTimeout(() => {
        setVisible(true);
      }, showDelay);

      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          // Generate random increment between 1 and 4
          const randomIncrement = Math.floor(Math.random() * 4) + 1;
          // Calculate new progress with random increment
          const newProgress = prev + randomIncrement;
          // Ensure we don't reach 100% until loading is complete
          return Math.min(newProgress, 98);
        });
      }, incrementInterval);

      // Set timeout for max duration
      timeoutRef.current = setTimeout(() => {
        setIsTimeout(true);
        setProgress(98); // Stop at 98% to show it's taking longer
      }, maxDuration);
    } else {
      setProgress(100);
      setTimeout(() => setVisible(false), 500); // Brief delay to show 100%
      clearInterval(intervalRef.current);
      clearTimeout(delayRef.current);
      clearTimeout(timeoutRef.current);
    }

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(delayRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, [loading, showDelay, incrementInterval, maxDuration]);

  const cancel = () => {
    clearInterval(intervalRef.current);
    clearTimeout(delayRef.current);
    clearTimeout(timeoutRef.current);
    setVisible(false);
    setProgress(0);
  };

  return {
    progress,
    showProgressModal: visible,
    cancel,
  };
};
